import React from 'react'
import { Link } from 'react-router-dom'
import AuthBase from '../../containers/auth-base'
import { ENVPRE } from 'app-config/index.js'
function GenericError(props) {
    const account = localStorage.getItem(`${ENVPRE}account`)

    return (
        <AuthBase background="sheep" mobileBackground="sheep" bottom={null}>
            <div style={{ textAlign: 'left' }}>
                <h1 className="fs-headline">Something’s wrong here…</h1>

                <p className="fs-base my-16">An unrecoverable error occured that prevented this page from being displayed. This could be due to the following reasons:</p>

                <ul>
                    <li>
                        <p>An internal farmdeck.com error occured</p>
                    </li>
                    <li>
                        <p>The URL was incorrectly entered</p>
                    </li>
                    <li>
                        <p>The file, asset or sensor no longer exists</p>
                    </li>
                </ul>

                <p className="fs-base my-16">
                    To continue, you should
                    {account ? (
                        <>
                            {' '}
                            <Link to={`/${account}/dashboard`}>return to the dashboard</Link> or{' '}
                        </>
                    ) : null}
                    <Link to={'/auth/logout'}> logout</Link> and retry.
                </p>

                <p className="fs-base my-16">
                    If this problem persists, please contact{' '}
                    <a href="mailto:support@farmdeck.com" target="_blank" rel="noreferrer">
                        Technical Support.
                    </a>
                </p>
            </div>
        </AuthBase>
    )
}

export default GenericError
